import { useMemo } from "react";
import { useSelector } from "react-redux";

import { copy } from "shared/assets";
import { IJSONAPIErrorCodes } from "shared/types";
import { dataMetaSelector } from "Bands/state";

const {
  permissions: { editPermissions: editPermissionsCopy },
} = copy;

export const useLastMemberWithPermissionError = (action: string) => {
  const { api: apiMeta } = useSelector(dataMetaSelector(action));

  const error = useMemo(() => {
    if (
      apiMeta?.error?.errorCodes.includes(
        IJSONAPIErrorCodes.LastMemberWithPermissionException
      )
    ) {
      return editPermissionsCopy.messages.lastMember;
    }

    return undefined;
  }, [apiMeta?.error?.errorCodes]);

  return { error };
};
